import React, { useEffect, useState, useRef } from "react";
import { useHistory, withRouter, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
    WebUrl,
    ApiUrl,
    ApiKey,
    AlertTypes,
    PhoneNumberPrefix,
} from "../../util/Constant";
import { useTranslation } from "react-i18next";
import Input from "../../components/custom/Input";
import ApiEngine from "../../util/ApiEngine.js";
import {
    stringIsNullOrEmpty,
    isObjectEmpty,
    createFormBody,
} from "../../util/Util.js";
import { setBusy, setIdle, showMessage } from "../../redux/AppAction.js";
import SecureLS from "secure-ls";
import CreatePasswordDesktop from "components/desktop/CreatePassword";

/// <summary>
/// Author: -
/// </summary>
const CreateAnAccountDesktop = (props) => {
    var { t, i18n } = useTranslation();
    var _dispatch = useDispatch();
    var userData = useSelector((state) => state.authState.userData);
    var _history = useHistory();
    let _location = useLocation();
    var ls = new SecureLS();
    const [referralCode, setReferralCode] = useState("");
    const [uplineDetail, setUplineDetail] = useState([]);
    const [uplineUsername, setUplineUsername] = useState("");
    const [formattedPhone, setFormattedPhone] = useState("");
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [_username, _setUsername] = useState("");
    const [isUsernameAvailable, setIsUsernameAvailable] = useState();
    const [isDigit, setIsDigit] = useState(false);
    const {
        register,
        handleSubmit,
        errors,
        clearErrors,
        setError,
        setValue,
        getValues,
        watch,
        control,
        trigger,
        phoneNumberChk,
    } = useForm({
        mode: "onBlur",
    });
    const [selectedPhonePrefix, setSelectedPhonePrefix] = useState(
        PhoneNumberPrefix[0].value
    );
    const [channels, setChannels] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState();
    const [toggleModal, setToggleModal] = useState();
    const [whatsappUrl, setWhatsappUrl] = useState("");
    const [telegramUrl, setTelegramUrl] = useState("");
    const [chatSphereNumber, setChatSphereNumber] = useState([]);
    const _APPEND_REGISTER_WHATSAPP_URL = "?text=register%20";
    const _APPEND_REGISTER_TELEGRAM_URL = "?start=";
    const [isCreateAnAccount, setIsCreateAnAccount] = useState(true);
    const [isCreatePassword, setIsCreatePassword] = useState(false);
    const [dataToPass, setDataToPass] = useState([]);

    useEffect(() => {
        if (selectedChannel) {
            if (!stringIsNullOrEmpty(selectedChannel.attachment)) {
                setToggleModal(true);
            }
        }
    }, [selectedChannel]);

    useEffect(() => {
        const receivedRreferralCode = props?.code;
        logSession(receivedRreferralCode);
        if (!stringIsNullOrEmpty(receivedRreferralCode)) {
            setReferralCode(receivedRreferralCode);
            getUpline(receivedRreferralCode);
        } 
    }, []);

    useEffect(() => {
        fetch(ApiUrl._API_GET_COMMUNICATION_CHANNELS + "?all=true", {
            method: ApiKey._API_GET,
            headers: {
                "Content-Type": ApiKey._API_FORM_URLENCODED,
                "X-Requested-With": ApiKey._API_XML_HTTP_REQUEST_KEY,
            },
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson[ApiKey._API_SUCCESS_KEY]) {
                    setChannelData(responseJson[ApiKey._API_DATA_KEY]);
                }
            });
    }, [])
        useEffect(() => {
            getChatSphereNumbers()
        }, []);


    async function getChatSphereNumbers() {
        const search = window.location.search;
        const params = new URLSearchParams(search);

        let responseJson = await ApiEngine.get(
            ApiUrl._API_GET_CHAT_SPHERE_NUMBERS
        );
        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            setChatSphereNumber(responseJson[ApiKey._API_DATA_KEY]);
            var number = responseJson[ApiKey._API_DATA_KEY].find(
                (x) => x.usage === "Whatsapp"
            ).phoneNumber;
            setWhatsappUrl("https://wa.me/" + number + _APPEND_REGISTER_WHATSAPP_URL + params.get("code"))

            setChatSphereNumber(responseJson[ApiKey._API_DATA_KEY]);
            var number = responseJson[ApiKey._API_DATA_KEY].find(
                (x) => x.usage === "Telegram"
            ).phoneNumber;
            setTelegramUrl("https://t.me/" + number + _APPEND_REGISTER_TELEGRAM_URL + params.get("code"))
        }
    }

    function setChannelData(data) {
        var channels = [];
        data.map((d, index) => {
            var channel = {
                name: d.channelName,
                description: d.channelDescription,
                actionUrl: d.cta,
                image: d.channelImage,
                attachment: d.attachment,
            };

            channels.push(channel);
        });
        setChannels(channels);
    }

    async function logSession(code) {
        let params = {
            referralCode: code,
        };
        let logJson = await ApiEngine.post(
            ApiUrl._API_ADD_OPERATION_LOG,
            createFormBody(params)
        );
        if (logJson[ApiKey._API_SUCCESS_KEY]) {
            console.log("done");
        }
    }

    async function getUpline(code) {
        let responseJson = await ApiEngine.get(
            ApiUrl._API_GET_UPLINE_BY_REFERRAL_CODE + "?code=" + code
        );
        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            const username = responseJson[ApiKey._API_DATA_KEY].username;

            let UplineUsername = username;

            setUplineDetail(responseJson[ApiKey._API_DATA_KEY]);
            setUplineUsername(UplineUsername);
        } else {
            _dispatch(
                showMessage({
                    type: AlertTypes._ERROR,
                    content: t(responseJson[ApiKey._API_MESSAGE_KEY]),
                })
            );
        }
    }

    async function checkUsername(username) {
        let avail = true;
        let responseJson = await ApiEngine.get(
            ApiUrl._API_CHECK_USERNAME +
                "?username=" +
                username +
                "&code=" +
                referralCode
        );
        avail = responseJson[ApiKey._API_SUCCESS_KEY];
        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            setIsUsernameAvailable(true);
        } else {
            setIsUsernameAvailable(false);
        }

        return avail;
    }

    const validateUsername = (e) => {
        var regexp = /^[\S]*^[^ \[\]`~\/!@#$%^&*()"':;?|{}=+_<>,.\\-]*$/g;
        if (e.nativeEvent.data === null || regexp.test(e.nativeEvent.data)) {
            _setUsername(e.target.value);
        }
    };

    function onchange(e) {
        const re = /^[0-9\b]+$/;
        // if (e.target.value === "" || re.test(e.target.value) )
        if (e.target.value.match(re) !== null) {
            setIsDigit(true);
            //  setFormattedPhone(selectedPhonePrefix + e.target.value)
            setFormattedPhone(e.target.value);
        } else {
            setIsDigit(false);
        }
    }

    const submitForm = async (data, e) => {
        _dispatch(setBusy());

        if (
            typeof formattedPhone !== "undefined" &&
            (selectedPhonePrefix + formattedPhone).length >= 10
        ) {
            if (!errors.phoneNumber) {
                // JW: directly create password without verify phine nnumber
                setDataToPass({
                    username: data.username,
                    email: data.email,
                    phoneNumber: selectedPhonePrefix + formattedPhone,
                    referralCode: referralCode
                });
                setIsCreateAnAccount(false);
                setIsCreatePassword(true);
            }
        } else {
            setError("registerPhone", { message: t("INVALID_PHONE_NUMBER") });
        }

        _dispatch(setIdle());
    };

    function handleClick(channel) {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
                JSON.stringify({
                    action: "chat",
                    //url: `${channel.actionUrl}`,
                    url:
                        channel.actionUrl.match(/live-chat/i) != null
                            ? `${window.location.origin}${channel.actionUrl}`
                            : `${channel.actionUrl}`,
                })
            );
        } else {
            if (!stringIsNullOrEmpty(channel.actionUrl)) {
                setToggleModal(false);
                window.location.href = channel.actionUrl;
            } else {
                setSelectedChannel(channel);
                setToggleModal(true);
            }
        }
    }

    return (
        <>
            {isCreateAnAccount && (
                <div>
                    <h3 className="mt-2 mb-4 text-center">{t("CREATE_AN_ACCOUNT")}</h3>
                    {/* <div className="ca-referrer-box">
                        <p className="font12 mb-0 text-lgray6">{t("YOUR_REFERRER")}</p>
                        <p className="mb-0 font20">{uplineUsername}</p>
                    </div> */}
                    <div className="custom-form">
                        <label>{t("YOUR_REFERRER")}</label>
                        <input 
                            value={props?.code}
                            disabled={true}
                            className="read-only"
                        />
                    </div>
                    <form
                        className="mb-5 custom-form text-left"
                        onSubmit={handleSubmit(submitForm)}
                    >
                        <label>{t("ENTER_USERNAME")}</label>
                        <Input
                            ref={register({
                                required: true,
                                validate: async (value) =>
                                    (await checkUsername(value)) ||
                                    (console.log("test"), "USERNAME_TAKEN"),
                                pattern: {
                                    value: /^(?=.*[A-Za-z0-9])[A-Za-z0-9]{4,9}$/i,
                                    message: t(
                                        "USERNAME_REQUIRES_ALPHANUMERIC_WITH_LOWERCASE_MINIMUM_4_9_CHARACTERS_ONLY"
                                    ),
                                },
                            })}
                            id="loginUsername"
                            name="username"
                            // label={t("ENTER_USERNAME")}
                            placeholder={t("ENTER_USERNAME")}
                            value={_username.toLowerCase()}
                            onInput={(e) => validateUsername(e)}
                            errors={errors}
                            className="mb-0 text-lowercase"
                            autoFocus
                        />

                        {isObjectEmpty(errors) && isUsernameAvailable && _username != "" && (
                            <div className="d-flex align-items-center user-available mb-4">
                                <div className="first">
                                    <img
                                        src={require("../../assets/img/new_icons/green.png")}
                                        className="img-responsive"
                                        alt="check"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="font12 text-lgray3 second text-customgreen">
                                    {t("THIS_USERNAME_IS_AVAILABLE")}
                                </div>
                            </div>
                        )}

                        <label>{t("MOBILE_NUMBER")}</label>
                        <div className="contact-number-box">
                            <div className="first">
                                <select onChange={(e) => setSelectedPhonePrefix(e.target.value)}>
                                    {PhoneNumberPrefix.map((prefix, index) => {
                                        return (
                                            <option
                                                key={index}
                                                className={"phone-prefix-" + (index + 1)}
                                                value={prefix.value}
                                            >
                                                {prefix.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                            <div className="second">
                                <input
                                    name="registerPhone"
                                    className="pl-3"
                                    placeholder="12345678"
                                    autoComplete="off"
                                    ref={register({
                                        required: true,
                                        minLength: {
                                            value: 8,
                                            message: t("MIN_CHARACTERS", { length: 8 }),
                                        },
                                        pattern: {
                                            value: /^[0-9]+$/g,
                                            message:
                                                t("MIN_CHARACTERS", { length: 8 }) +
                                                " " +
                                                t("AND") +
                                                " " +
                                                t("ONLY_NUMBERS"),
                                        },
                                    })}
                                    errors={errors}
                                    onChange={(e) => {
                                        // Remove any leading zeros
                                        e.target.value = e.target.value.replace(/^0+/, '');
                                        onchange(e);
                                    }}
                                />
                            </div>
                        </div>

                        {phoneNumberError == true ? (
                            <div className="d-flex align-items-center user-available mb-4">
                                <div className="font12 text-lgray3 second text-customred">
                                    Number not available
                                </div>
                            </div>
                        ) : errors.registerPhone ? (
                            <div className="d-flex align-items-center user-available mb-4">
                                <div className="font12 text-lgray3 second text-customred">
                                    {t(errors.registerPhone.message)}
                                </div>
                            </div>
                        ) : (
                            ""
                        )}

                        <div>
                            <button className="btn btn-custom font20 mt-4 mb-3">
                                {t("REGISTER")}
                            </button>
                        </div>
                        {/* <button
                            className="btn btn-custom font20 mt-4"
                            onClick={() => {
                                if (whatsappUrl != "") {
                                    window.open(whatsappUrl)
                                }
                            }}
                        >
                            <div>
                                {t("REGISTER_WITH_WHATSAPP")}
                            </div>
                            <div>
                                <img src={require("../../assets/img/icon/ri_whatsapp-line.svg")} alt="back" className="img-responsive" loading="lazy"/>
                            </div>
                        </button> */}
                        <button
                            className="btn btn-custom font20 mt-4"
                            onClick={() => {
                                if (telegramUrl != "") {
                                    window.open(telegramUrl)
                                }
                            }}
                        >
                            <div>
                                {t("REGISTER_WITH_TELEGRAM")}
                            </div>
                            <div>
                                <img src={require("../../assets/img/icon/telegram.svg")} alt="back" className="img-responsive" loading="lazy"/>
                            </div>
                        </button>

                        {channels.map((channel, index) => {
                            if (channel.name == "Telegram") {
                                return (
                                    <div
                                        key={index}
                                        className="live-chat-box mt-3"
                                        onClick={() => {
                                            if (!stringIsNullOrEmpty(channel.actionUrl)) {
                                                handleClick(channel);
                                            } else if (channel.name == "Livechat") {
                                            }
                                        }}
                                        style={{
                                            borderBottom: "unset",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <div
                                            className="first"
                                            style={{
                                                border: "1px solid",
                                                padding: "10px",
                                                borderRadius: "10px",
                                            }}
                                        >
                                            <div>
                                                <img
                                                    src={channel.image}
                                                    className="img-responsive border-radius-100"
                                                    alt="icon"
                                                    style={{ width: "25px", height: "25px" }}
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div>
                                                <h6
                                                    className="mb-0"
                                                    style={{ color: "unset", fontWeight: "normal" }}
                                                >
                                                    {t("CUSTOMER_SERVICE")}
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        })}
                    </form>
                </div>
            )}
            {isCreatePassword && (
                <CreatePasswordDesktop
                    username={dataToPass.username}
                    email={dataToPass.email}
                    phoneNumber={dataToPass.phoneNumber}
                    referralCode={dataToPass.referralCode}
                />
            )}
        </>
        
    );
};

export default withRouter(CreateAnAccountDesktop);
